// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.item-title {
  font-size: 1.4285714286rem;
  font-weight: bold;
  color: #ffffff;
  z-index: 10;
  text-align: center;
  margin-top: 2rem;
}

.item-count {
  margin-top: 5rem;
}

.item-title-fade {
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  height: 5rem;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.number {
  font-size: 2.8571428571rem;
  font-weight: bold;
  color: #6b645e;
}

.inner {
  height: 7.7142857143rem;
  width: 7.7142857143rem;
  background: #ffcd00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.outer {
  height: 14.5rem;
  width: 14.5rem;
  background: rgba(255, 205, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plus-minus-btn {
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: transparent;
}
.plus-minus-btn.plus-btn {
  background-image: url("/assets/images/plus-white.svg");
}
.plus-minus-btn.plus-btn:active {
  background-image: url("/assets/images/plus-white.svg");
}
.plus-minus-btn.minus-btn {
  background-image: url("/assets/images/minus-white.svg");
}
.plus-minus-btn.minus-btn:active {
  background-image: url("/assets/images/minus-white.svg");
}

.control-btn {
  border-radius: 3.4285714286rem;
  font-size: 0.8571428571rem;
  font-weight: bold;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 8.7857142857rem;
  border-width: 2px;
}
.control-btn.btn-outline-primary {
  border: 2px solid rgb(255, 205, 0);
}

.modal-body {
  border-radius: 16px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.message {
  color: #a5a498;
  font-weight: bold;
  margin-bottom: 2rem;
}

.cancel-button {
  background-color: rgba(0, 0, 0, 0.24);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/item-selector/component/add-to-tray/add-to-tray.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;ECqCE,0BAAA;EDnCA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EC4BE,gBAAA;AD5BF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,oCAAA;ECqBA,YAAA;EDnBA,WAAA;EACA,4BClBY;EDmBZ,6BCnBY;ADkBd;;AAIA;ECcE,0BAAA;EDZA,iBAAA;EACA,cCnBW;ADkBb;;AAIA;ECQE,uBAAA;EAAA,sBAAA;EDLA,mBCxCQ;EDyCR,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;ECFE,eAAA;EAAA,cAAA;EDKA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAIA;ECZE,YAAA;EAAA,WAAA;EDeA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,6BAAA;AADF;AAGE;EACE,sDAAA;AADJ;AAEI;EACE,sDAAA;AAAN;AAIE;EACE,uDAAA;AAFJ;AAGI;EACE,uDAAA;AADN;;AAMA;ECnCE,8BAAA;EAAA,0BAAA;EDsCA,iBAAA;ECtCA,iBAAA;EAAA,oBAAA;EAAA,sBAAA;ED0CA,iBAAA;AAHF;AAKE;EACE,kCAAA;AAHJ;;AAOA;EACE,mBCtFY;EDuFZ,4BAAA;EACA,sBAAA;EACA,2BAAA;AAJF;;AAOA;EACE,cCpFgB;EDqFhB,iBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,qCAAA;EACA,YAAA;AAJF","sourcesContent":["@import 'variables';\n\n:host {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.item-title {\n  @include pixelToRem(font-size, 20px);\n  font-weight: bold;\n  color: #ffffff;\n  z-index: 10;\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.item-count {\n  @include pixelToRem(margin-top, 70px);\n}\n\n.item-title-fade {\n  position: absolute;\n  top: 0;\n  background-color: rgba(#000000, 0.2);\n  @include pixelToRem(height, 70px);\n  width: 100%;\n  border-top-left-radius: $tray-radius;\n  border-top-right-radius: $tray-radius;\n}\n\n.number {\n  @include pixelToRem(font-size, 40px);\n  font-weight: bold;\n  color: $text-color;\n}\n\n.inner {\n  @include pixelToRem(height, 108px);\n  @include pixelToRem(width, 108px);\n  background: $primary;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.outer {\n  @include pixelToRem(height, 203px);\n  @include pixelToRem(width, 203px);\n  background: rgba($primary, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.plus-minus-btn {\n  @include pixelToRem(height, 56px);\n  @include pixelToRem(width, 56px);\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: transparent;\n\n  &.plus-btn {\n    background-image: url('/assets/images/plus-white.svg');\n    &:active {\n      background-image: url('/assets/images/plus-white.svg');\n    }\n  }\n\n  &.minus-btn {\n    background-image: url('/assets/images/minus-white.svg');\n    &:active {\n      background-image: url('/assets/images/minus-white.svg');\n    }\n  }\n}\n\n.control-btn {\n  @include pixelToRem(border-radius, $button-border-radius);\n  @include pixelToRem(font-size, 12px);\n  font-weight: bold;\n  @include pixelToRem(padding-top, 14px);\n  @include pixelToRem(padding-bottom, 14px);\n  @include pixelToRem(width, 123px);\n  border-width: 2px;\n\n  &.btn-outline-primary {\n    border: 2px solid $primary-btn-border;\n  }\n}\n\n.modal-body {\n  border-radius: $tray-radius;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.message {\n  color: $info-text-color;\n  font-weight: bold;\n  margin-bottom: 2rem;\n}\n\n.cancel-button {\n  background-color: rgba(0, 0, 0, 0.24);\n  color: white;\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
